export const baseApiUrl = process.env.VUE_APP_BASE_API_URL;
export const ungerboeckEnvironment = process.env.VUE_APP_UNGERBOECK_ENV;